import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface DeleteDialogProps {
  open: boolean;
  webhookName: string | null;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({
  open,
  webhookName,
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onClose} aria-labelledby="delete-dialog-title">
    <DialogTitle id="delete-dialog-title">Delete Webhook</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete the webhook &ldquo;{webhookName}&rdquo;?
        This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} variant="contained" color="error" autoFocus>
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteDialog;
